import { Component } from '@angular/core';

@Component({
  selector: 'moduurnv2-deals-apply',
  templateUrl: './deals-apply.component.html',
  styleUrls: ['./deals-apply.component.scss'],
})
export class DealsApplyComponent {}
